import React from 'react';
import { Divider, Icon, Message } from 'semantic-ui-react';
import { ResumenDeCurso } from 'src/api/protocolo/horarios';
import { TablaDeAsistenciasDelBloque } from './TablaDeAsistencias';
import { AsistenciaDelAlumnoDTO } from './tipos';

export type Props = {
    asistencia?: AsistenciaDelAlumnoDTO;
    todosLosCursos?: Map<string, ResumenDeCurso>;
};

const AsistenciaDelAlumno = (props: Props) => {
    const { asistencia, todosLosCursos } = props;

    if (!todosLosCursos) {
        return <Icon loading name='spinner' />;
    }

    if (!asistencia || Object.values(asistencia.porBloque).every(c => c.length === 0)) {
        return <Message info>El alumno no posee asistencias registradas.</Message>;
    }

    const { porBloque, cursosInscritos } = asistencia;

    const nombresDeBloquesInscritos = new Set(cursosInscritos.map(b => b.split('-')[0]));
    const bloquesYaNoInscritos = Object.keys(porBloque).filter(
        bloque => !nombresDeBloquesInscritos.has(bloque),
    );

    return (
        <div>
            <TablaDeAsistenciasDelBloque
                plan='anual'
                porBloque={porBloque}
                bloques={cursosInscritos}
            />
            <TablaDeAsistenciasDelBloque
                plan='intensivo'
                porBloque={porBloque}
                bloques={cursosInscritos}
            />
            <TablaDeAsistenciasDelBloque
                plan='intensivo-vespertino'
                porBloque={porBloque}
                bloques={cursosInscritos}
            />
            <TablaDeAsistenciasDelBloque
                plan='electivo'
                porBloque={porBloque}
                bloques={cursosInscritos}
            />

            <Divider hidden />

            {bloquesYaNoInscritos.length > 0 && (
                <Message compact>
                    El alumno tuvo asistencia en cursos de la(s) asignatura(s){' '}
                    {bloquesYaNoInscritos.join(', ')}, pero no están inscritos actualmente.
                </Message>
            )}
        </div>
    );
};

export default AsistenciaDelAlumno;



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/FichaDeAlumno/paginas/AsistenciaDelAlumno/index.tsx